const normalizeAlphaNumericOrSpace = (value: string): string => {
  if (!value) {
    return value;
  }
  return value.replace(/[^a-zA-Z0-9 ]/g, '');
};

export default normalizeAlphaNumericOrSpace;
